
(function() {
  var sgSizes = [
    {us:'3',uk:'F',eu:'44',d:14.1},{us:'3.5',uk:'G',eu:'45',d:14.5},
    {us:'4',uk:'H',eu:'47',d:14.9},{us:'4.5',uk:'I',eu:'48',d:15.3},
    {us:'5',uk:'J',eu:'49',d:15.7},{us:'5.5',uk:'K',eu:'51',d:16.1},
    {us:'6',uk:'L',eu:'52',d:16.5},{us:'6.5',uk:'M',eu:'53',d:16.9},
    {us:'7',uk:'N',eu:'54',d:17.3},{us:'7.5',uk:'O',eu:'56',d:17.7},
    {us:'8',uk:'P',eu:'57',d:18.1},{us:'8.5',uk:'Q',eu:'58',d:18.5},
    {us:'9',uk:'R',eu:'60',d:18.9},{us:'9.5',uk:'S',eu:'61',d:19.4},
    {us:'10',uk:'T',eu:'62',d:19.8},{us:'10.5',uk:'U',eu:'63',d:20.2},
    {us:'11',uk:'V',eu:'65',d:20.6},{us:'11.5',uk:'W',eu:'66',d:21.0},
    {us:'12',uk:'X',eu:'67',d:21.4},{us:'12.5',uk:'Y',eu:'68',d:21.8},
    {us:'13',uk:'Z',eu:'69',d:22.2},{us:'13.5',uk:'Z+1',eu:'70',d:22.6},
    {us:'14',uk:'Z+2',eu:'71',d:23.0},{us:'14.5',uk:'Z+3',eu:'72',d:23.4},
    {us:'15',uk:'Z+4',eu:'73',d:23.8}
  ];

  var currentUSSize = '7';
  var CARD_MM = 85.6;

  /* ---- screen calibration (px-per-mm) ---- */
  function sgDefaultPxMm() {
    try {
      var d = document.createElement('div');
      d.style.cssText = 'width:100mm;height:0;position:absolute;left:-9999px;top:-9999px';
      document.body.appendChild(d);
      var px = d.offsetWidth / 100;
      d.parentNode.removeChild(d);
      return px > 0 ? px : 3.7795;
    } catch (e) { return 3.7795; }
  }
  function sgPxMm() {
    var v;
    try { v = parseFloat(localStorage.getItem('sjwPxPerMm')); } catch (e) {}
    return (v && v > 0) ? v : sgDefaultPxMm();
  }
  function sgIsCalibrated() {
    try { return !!(parseFloat(localStorage.getItem('sjwPxPerMm')) > 0); } catch (e) { return false; }
  }
  function sgSizeCircle(mm) {
    var c = document.getElementById('sjw-sg-circle');
    if (!c) return;
    var px = Math.round(mm * sgPxMm());
    c.style.width = px + 'px';
    c.style.height = px + 'px';
  }

  function sgFindSize(mm) {
    var best = sgSizes[0], bd = Math.abs(mm - sgSizes[0].d);
    sgSizes.forEach(function(s) { var d = Math.abs(mm - s.d); if (d < bd) { bd = d; best = s; } });
    return best;
  }

  function sgBuildChart() {
    var tbody = document.getElementById('sjw-chart-body');
    if (!tbody || tbody.children.length) return;
    var common = ['6','6.5','7'];
    sgSizes.forEach(function(s) {
      var tr = document.createElement('tr');
      tr.setAttribute('data-us', s.us);
      if (common.indexOf(s.us) !== -1) tr.className = 'sjw-sg-hl';
      tr.innerHTML = '<td>' + s.us + '</td><td>' + s.uk + '</td><td>' + s.eu +
        '</td><td>' + s.d.toFixed(1) + ' mm</td><td>' + (s.d * Math.PI).toFixed(1) + ' mm</td>';
      tbody.appendChild(tr);
    });
  }

  function sgUpdateFinder() {
    var slider = document.getElementById('sjw-diam-slider');
    if (!slider) return;
    var mm = parseFloat(slider.value);
    var o = document.getElementById('sjw-diam-out');
    if (o) o.textContent = mm.toFixed(1) + ' mm';
    var numEl = document.getElementById('sjw-diam-num');
    if (numEl && document.activeElement !== numEl) numEl.value = mm.toFixed(1);
    sgSizeCircle(mm);
    var s = sgFindSize(mm);
    currentUSSize = s.us;
    var us = document.getElementById('sjw-r-us');
    var uk = document.getElementById('sjw-r-uk');
    var eu = document.getElementById('sjw-r-eu');
    var circ = document.getElementById('sjw-r-circ');
    if (us) us.textContent = s.us;
    if (typeof window.sjwSetGuideSize === 'function' && s.us) window.sjwSetGuideSize(String(s.us));
    if (uk) uk.textContent = s.uk;
    if (eu) eu.textContent = s.eu;
    if (circ) circ.textContent = (s.d * Math.PI).toFixed(1) + ' mm';
    var btnLabel = document.getElementById('sjw-btn-size-label');
    if (btnLabel) btnLabel.textContent = s.us;
    var confirm = document.getElementById('sjw-size-confirm');
    if (confirm) confirm.style.display = 'none';
    var cl = document.getElementById('sjw-sg-calib-open');
    if (cl) cl.textContent = sgIsCalibrated() ? 'Re-calibrate screen' : 'Calibrate screen for exact size';
  }

  /* Native range dragging can be swallowed by the modal's mobile scroll lock.
     Keep the native control, but map an active pointer to its value as a
     narrowly-scoped fallback so touch, pen and mouse drags stay responsive. */
  function sgBindRangeDrag(input) {
    if (!input || input.__sjwRangeDrag) return;
    input.__sjwRangeDrag = 1;
    var activePointer = null;

    function setFromX(clientX) {
      var rect = input.getBoundingClientRect();
      if (!rect.width) return;
      var min = parseFloat(input.min || '0');
      var max = parseFloat(input.max || '100');
      var step = parseFloat(input.step || '1');
      var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      var value = min + ((max - min) * ratio);
      if (step > 0) value = min + (Math.round((value - min) / step) * step);
      value = Math.max(min, Math.min(max, value));
      var decimals = step > 0 && String(step).indexOf('.') !== -1 ? String(step).split('.')[1].length : 0;
      var next = value.toFixed(decimals);
      if (input.value === next) return;
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    input.addEventListener('pointerdown', function(e) {
      if (e.button != null && e.button !== 0) return;
      activePointer = e.pointerId;
      try { input.setPointerCapture(e.pointerId); } catch (_) {}
      try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
      setFromX(e.clientX);
      e.preventDefault();
    });
    input.addEventListener('pointermove', function(e) {
      if (activePointer !== e.pointerId) return;
      setFromX(e.clientX);
      e.preventDefault();
    });
    function finish(e) {
      if (activePointer !== e.pointerId) return;
      setFromX(e.clientX);
      try { input.releasePointerCapture(e.pointerId); } catch (_) {}
      activePointer = null;
    }
    input.addEventListener('pointerup', finish);
    input.addEventListener('pointercancel', function(e) {
      if (activePointer === e.pointerId) activePointer = null;
    });
  }

  /* ---- chart converter ---- */
  var convI = 8, convSys = 'us';
  function sgRenderConv() {
    var r = sgSizes[convI];
    var val = (convSys === 'd') ? r.d.toFixed(1) + ' mm' : r[convSys];
    var sysL = { us:'US size', uk:'UK size', eu:'EU size', d:'Diameter' }[convSys];
    var v = document.getElementById('sjw-conv-val'),
        s = document.getElementById('sjw-conv-sys'),
        o = document.getElementById('sjw-conv-out');
    if (v) v.textContent = val;
    if (s) s.textContent = sysL;
    if (o) o.innerHTML = 'US ' + r.us + ' &middot; UK ' + r.uk + ' &middot; EU ' + r.eu +
      ' &middot; ' + r.d.toFixed(1) + ' mm &Oslash; &middot; ' + (r.d * Math.PI).toFixed(1) + ' mm';
    var tb = document.getElementById('sjw-chart-body');
    if (tb) {
      [].forEach.call(tb.children, function(tr) {
        tr.classList.toggle('sjw-sg-hl2', tr.getAttribute('data-us') === r.us);
      });
    }
    currentUSSize = r.us;
    if (typeof window.sjwSetGuideSize === 'function') window.sjwSetGuideSize(String(r.us));
  }
  function sgConvInit() {
    var seg = document.getElementById('sjw-conv-seg');
    if (!seg || seg.__sgi) return;
    seg.__sgi = 1;
    [].forEach.call(seg.querySelectorAll('button'), function(b) {
      b.addEventListener('click', function() {
        convSys = b.getAttribute('data-cs');
        [].forEach.call(seg.querySelectorAll('button'), function(x) { x.classList.remove('on'); });
        b.classList.add('on');
        sgRenderConv();
      });
    });
    var p = document.getElementById('sjw-conv-prev'), n = document.getElementById('sjw-conv-next');
    if (p) p.addEventListener('click', function() { convI = Math.max(0, convI - 1); sgRenderConv(); });
    if (n) n.addEventListener('click', function() { convI = Math.min(sgSizes.length - 1, convI + 1); sgRenderConv(); });
    sgRenderConv();
  }

  function sgSelectSizeOnPage(usSize) {
    if (typeof window.sjwApplySize === 'function') {
      window.sjwApplySize(String(usSize));
      return true;
    }
    return false;
  }

  function injectPageBanner(usSize) {
    var existing = document.getElementById('sjw-page-size-banner');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.id = 'sjw-page-size-banner';
    banner.style.cssText = [
      'margin-top:10px','padding:10px 16px','background:rgba(34,139,34,0.07)',
      'border:1px solid rgba(34,139,34,0.22)','border-radius:8px','display:flex',
      'align-items:center','justify-content:space-between','gap:12px','font-size:calc(13px * var(--sjw-scale))',
      'font-family:inherit','color:inherit'
    ].join(';');

    banner.innerHTML =
      '<span style="color:#1a6b1a;display:flex;align-items:center;gap:6px;flex:1;">' +
        '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" style="flex-shrink:0;">' +
          '<circle cx="8" cy="8" r="7" stroke="#1a6b1a" stroke-width="1.5"/>' +
          '<path d="M4.5 8l2.5 2.5 4.5-4.5" stroke="#1a6b1a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        'Size <strong style="margin:0 3px;">' + usSize + '</strong> noted — please select it below' +
      '</span>' +
      '<button type="button" id="sjw-banner-change" style="font-size:calc(11px * var(--sjw-scale));color:#888;background:none;border:none;cursor:pointer;text-decoration:underline;padding:0;font-family:inherit;white-space:nowrap;flex-shrink:0;">Change</button>';

    var sizeGrid = document.querySelector('[data-size-grid]');
    var insertAfter = sizeGrid ? sizeGrid.closest('fieldset') : null;
    if (insertAfter && insertAfter.parentNode) {
      insertAfter.parentNode.insertBefore(banner, insertAfter.nextSibling);
    } else {
      var opts = document.querySelector('.product-options');
      if (opts) opts.appendChild(banner);
    }

    var changeBtn = document.getElementById('sjw-banner-change');
    if (changeBtn) {
      changeBtn.addEventListener('click', function() {
        try { sessionStorage.removeItem('sjw_selected_size'); } catch(e) {}
        var b = document.getElementById('sjw-page-size-banner');
        if (b) b.remove();
        document.querySelectorAll('[data-size-grid]').forEach(function(g) { g.style.display = 'flex'; });
        document.querySelectorAll('[data-size-display]').forEach(function(d) { d.classList.remove('is-visible'); });
        if (typeof window.sjwOpenSizeGuide === 'function') {
          window.sjwOpenSizeGuide(changeBtn);
        } else {
          var overlay = document.querySelector('[data-sjw-size-guide-overlay]');
          if (overlay) {
            overlay.style.display = 'flex';
            overlay.setAttribute('aria-hidden', 'false');
            if (window.SJW_PDP_MODAL) window.SJW_PDP_MODAL.lock('ring-size', overlay.firstElementChild || overlay, changeBtn, overlay.firstElementChild || overlay);
            else document.body.style.overflow = 'hidden';
          }
        }
      });
    }
  }

  function showConfirm(usSize, success) {
    var confirmEl = document.getElementById('sjw-size-confirm');
    try { sessionStorage.setItem('sjw_selected_size', usSize); } catch(e) {}

    if (confirmEl) {
      confirmEl.style.cssText = 'display:block;margin-top:10px;padding:10px 14px;background:rgba(34,139,34,0.08);border:1px solid rgba(34,139,34,0.25);border-radius:8px;font-size:calc(12px * var(--sjw-scale));color:#1a6b1a;text-align:center;';
      if (success) {
        confirmEl.innerHTML = '&#10003; Size <strong>' + usSize + '</strong> selected! Closing...';
      } else {
        confirmEl.innerHTML = '&#10003; Size <strong>' + usSize + '</strong> saved! Please select it from the options below.';
      }
    }

    /* The custom PDP applies the size directly. A second page banner reflows the
       buy box after the sheet closes, so only use it on legacy pages. */
    if (!success) injectPageBanner(usSize);

    setTimeout(function() {
      var overlay = document.querySelector('[data-sjw-size-guide-overlay]');
      if (overlay) {
        if (typeof window.sjwCloseSizeGuide === 'function') window.sjwCloseSizeGuide();
        else {
          overlay.style.display = 'none';
          overlay.setAttribute('aria-hidden', 'true');
          if (window.SJW_PDP_MODAL) window.SJW_PDP_MODAL.unlock('ring-size');
          else document.body.style.overflow = '';
        }
        try {
          var saved = sessionStorage.getItem('sjw_selected_size');
          if (saved && window.sjwCollapseSize) window.sjwCollapseSize(saved);
        } catch(e) {}
      }
    }, success ? 120 : 2000);
  }

  function sgSwitchTab(name) {
    var wrap = document.getElementById('sjw-size-guide');
    if (!wrap) return;
    wrap.querySelectorAll('[data-sgtab]').forEach(function(btn) {
      var active = btn.dataset.sgtab === name;
      btn.classList.toggle('active', active);
      btn.style.setProperty('opacity',             active ? '1'            : '0.55',        'important');
      btn.style.setProperty('font-weight',         active ? '500'          : '400',         'important');
      btn.style.setProperty('border-bottom-color', active ? 'currentColor' : 'transparent', 'important');
    });
    wrap.querySelectorAll('[data-sgpane]').forEach(function(p) {
      p.style.setProperty('display', p.dataset.sgpane === name ? 'block' : 'none', 'important');
    });
    if (name === 'chart') { sgBuildChart(); sgConvInit(); }
    if (name === 'finder') sgSizeCircle(parseFloat((document.getElementById('sjw-diam-slider')||{}).value || 17.3));
  }

  function sgInitCalibration() {
    var openBtn = document.getElementById('sjw-sg-calib-open');
    var panel   = document.getElementById('sjw-sg-calib');
    var card    = document.getElementById('sjw-sg-card');
    var cslider = document.getElementById('sjw-sg-card-slider');
    if (!openBtn || !panel || !card || !cslider) return;
    function drawCard() {
      var w = parseFloat(cslider.value);
      card.style.width = w + 'px';
      card.style.height = Math.round(w / 1.586) + 'px';
    }
    openBtn.addEventListener('click', function() {
      var show = panel.style.display === 'none' || !panel.style.display;
      panel.style.display = show ? 'block' : 'none';
      if (show) { cslider.value = Math.round(sgPxMm() * CARD_MM); drawCard(); }
    });
    cslider.addEventListener('input', drawCard);
    sgBindRangeDrag(cslider);
    var saveBtn = document.getElementById('sjw-sg-calib-save');
    if (saveBtn) saveBtn.addEventListener('click', function() {
      var w = parseFloat(cslider.value);
      try { localStorage.setItem('sjwPxPerMm', (w / CARD_MM).toFixed(4)); } catch (e) {}
      panel.style.display = 'none';
      sgUpdateFinder();
    });
    var cancelBtn = document.getElementById('sjw-sg-calib-cancel');
    if (cancelBtn) cancelBtn.addEventListener('click', function() { panel.style.display = 'none'; });
  }

  function sgInit() {
    var wrap = document.getElementById('sjw-size-guide');
    if (!wrap) return;
    wrap.querySelectorAll('[data-sgtab]').forEach(function(btn) {
      btn.addEventListener('click', function() { sgSwitchTab(btn.dataset.sgtab); });
    });
    var slider = document.getElementById('sjw-diam-slider');
    if (slider) {
      slider.addEventListener('input', sgUpdateFinder);
      sgBindRangeDrag(slider);
    }
    var num = document.getElementById('sjw-diam-num');
    if (num) num.addEventListener('input', function() {
      var v = parseFloat(num.value);
      if (isNaN(v)) return;
      v = Math.max(14, Math.min(24, v));
      if (slider) slider.value = v;
      sgUpdateFinder();
    });
    var selectBtn = document.getElementById('sjw-select-size-btn');
    if (selectBtn) {
      selectBtn.addEventListener('click', function() {
        var success = sgSelectSizeOnPage(currentUSSize);
        showConfirm(currentUSSize, success);
      });
    }
    sgInitCalibration();
    sgSwitchTab('finder');
    sgUpdateFinder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sgInit);
  } else {
    sgInit();
  }
})();
